import { ExternalLink, Copy } from "lucide-react";
import { toast } from "sonner";

const GROUPS = [
  { title: "Public pages", note: "Anyone can open these", pages: [
    ["Home page & booking form", "/"],
    ["Recipes directory", "/recipes"],
    ["Dietitian hiring form", "/join-team"],
  ]},
  { title: "Admin panel", note: "Only you", pages: [
    ["Admin login", "/admin/login"],
    ["Admin dashboard (Clients, Leads, Blog, Applications)", "/admin"],
  ]},
  { title: "App", note: "Opens differently for you, dietitians and clients", pages: [
    ["App login", "/app/login"],
    ["App home", "/app"],
    ["Team (owner only)", "/app/team"],
    ["Diet templates", "/app/templates"],
    ["Chat", "/app/chat"],
    ["Weight tracker (clients)", "/app/weight"],
    ["Profile", "/app/profile"],
  ]},
];

function PageRow({ label, path }) {
  const url = `${window.location.origin}${path}`;
  const id = path === "/" ? "home" : path.replace(/\//g, "-").slice(1);
  return (
    <div className="flex items-center gap-3 py-3 border-t first:border-t-0" style={{ borderColor: "var(--border-subtle)" }}>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold">{label}</div>
        <div className="text-xs truncate" style={{ color: "var(--text-secondary)" }}>{path}</div>
      </div>
      <button data-testid={`allpages-copy-${id}`} onClick={() => { navigator.clipboard.writeText(url); toast.success("Link copied"); }} style={{ color: "var(--primary)" }}><Copy size={14} /></button>
      <a data-testid={`allpages-open-${id}`} href={path} target="_blank" rel="noreferrer" className="text-xs font-bold px-3 py-1 rounded-full inline-flex items-center gap-1" style={{ border: "1.5px solid var(--primary)", color: "var(--primary)" }}>
        Open <ExternalLink size={12} />
      </a>
    </div>
  );
}

export function AllPagesTab() {
  return (
    <div data-testid="all-pages-tab" className="grid md:grid-cols-3 gap-4">
      {GROUPS.map((g) => (
        <div key={g.title} className="card-soft p-5">
          <div className="font-display text-xl" style={{ color: "var(--primary)" }}>{g.title}</div>
          <div className="text-xs mb-2" style={{ color: "var(--text-secondary)" }}>{g.note}</div>
          {g.pages.map(([label, path]) => <PageRow key={path} label={label} path={path} />)}
        </div>
      ))}
    </div>
  );
}
